import Employee from "../Employee";
import { MonetaryAmount } from "../monetary-amount";

interface Recipient {
  name: string;
  surname: string;
  type: string;
  subtype: string;
  legalId?: string;
}

interface HealthModality {
  name: string;
  modalityFee: MonetaryAmount;
}

interface HealthComplement {
  name: string;
  complementFee: MonetaryAmount;
}

export interface RentingFile {
  fileId: string;
  fileName: string;
  name: string;
}

export interface Beneficiary {
  name: string;
  state: string;
  amount: MonetaryAmount;
  companyAmount: MonetaryAmount;
  employeeAmount: MonetaryAmount;
  date: Date;
}

export interface TrainingInfo {
  startDate: string | null;
  endDate: string | null;
}

export default class RecurrentPayment {
  id: string;

  category: string;

  employee: Employee;

  recipient: Recipient;

  requestDate: Date;

  initialDate: Date;

  finalDate: Date;

  effectiveDate: Date;

  nursery: string;

  course: string;

  centre: string;

  modality: string;

  insuranceCarrier: string;

  brand: string;

  amount: MonetaryAmount;

  companyAmount: MonetaryAmount;

  employeeAmount: MonetaryAmount;

  initialCompanyAmount: MonetaryAmount;

  initialEmployeeAmount: MonetaryAmount;

  healthModality: HealthModality;

  healthComplements: HealthComplement[];

  brochureUrl: string;

  rentingFiles: RentingFile[];

  state: string;

  approvals: any[];

  beneficiaries: Beneficiary[];

  payrollNumber: number;

  transactions: any[];

  rejectedReason: string;

  productName: string;

  trainingInfo: TrainingInfo;

  constructor({
    id,
    category = "",
    employee = new Employee({}),
    recipient = { name: "", surname: "", type: "", subtype: "" },
    requestDate = new Date(),
    initialDate = new Date(),
    finalDate = new Date(),
    effectiveDate = new Date(),
    nursery = "",
    course = "",
    centre = "",
    modality = "",
    insuranceCarrier = "",
    brand = "",
    amount = MonetaryAmount.ZERO,
    companyAmount = MonetaryAmount.ZERO,
    employeeAmount = MonetaryAmount.ZERO,
    initialCompanyAmount = MonetaryAmount.ZERO,
    initialEmployeeAmount = MonetaryAmount.ZERO,
    healthModality = {
      name: "",
      modalityFee: MonetaryAmount.ZERO,
    },
    healthComplements = [],
    brochureUrl = "",
    rentingFiles = [],
    state = "",
    approvals = [],
    beneficiaries = [],
    payrollNumber = 0,
    transactions = [],
    rejectedReason = "",
    productName = "",
    trainingInfo = {
      startDate: null,
      endDate: null,
    },
  }: {
    id: string;
    category: string;
    employee: Employee;
    recipient: Recipient;
    requestDate: Date;
    initialDate?: Date;
    finalDate?: Date;
    effectiveDate?: Date;
    nursery?: string;
    course?: string;
    centre?: string;
    modality?: string;
    insuranceCarrier?: string;
    brand?: string;
    amount: MonetaryAmount;
    companyAmount?: MonetaryAmount;
    employeeAmount?: MonetaryAmount;
    initialCompanyAmount?: MonetaryAmount;
    initialEmployeeAmount?: MonetaryAmount;
    healthModality?: HealthModality;
    healthComplements?: HealthComplement[];
    brochureUrl?: string;
    rentingFiles: RentingFile[];
    state: string;
    approvals: any[];
    beneficiaries: Beneficiary[];
    payrollNumber?: number;
    transactions: any[];
    rejectedReason?: string;
    productName?: string;
    trainingInfo?: TrainingInfo;
  }) {
    this.id = id;
    this.category = category;
    this.employee = employee;
    this.recipient = recipient;
    this.requestDate = requestDate;
    this.initialDate = initialDate;
    this.finalDate = finalDate;
    this.effectiveDate = effectiveDate;
    this.nursery = nursery;
    this.course = course;
    this.centre = centre;
    this.modality = modality;
    this.insuranceCarrier = insuranceCarrier;
    this.brand = brand;
    this.amount = amount;
    this.companyAmount = companyAmount;
    this.employeeAmount = employeeAmount;
    this.initialCompanyAmount = initialCompanyAmount;
    this.initialEmployeeAmount = initialEmployeeAmount;
    this.healthModality = healthModality;
    this.healthComplements = healthComplements;
    this.brochureUrl = brochureUrl;
    this.rentingFiles = rentingFiles;
    this.state = state;
    this.approvals = approvals;
    this.beneficiaries = beneficiaries;
    this.payrollNumber = payrollNumber;
    this.transactions = transactions;
    this.rejectedReason = rejectedReason;
    this.productName = productName;
    this.trainingInfo = trainingInfo;
  }

  modState = (state: string): RecurrentPayment =>
    new RecurrentPayment({ ...this, state });
}
